import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/app/[locale]/(legal)/privacy-policy/page.tsx");
